export const saintromualdTranslations = {
  // Hero
  breadcrumb_home: 'Accueil',
  breadcrumb_sectors: 'Secteurs',
  breadcrumb_current: 'Saint-Romuald',
  hero_h1: "Couvreur à Saint-Romuald : toiture, réfection et réparation",
  hero_subtitle: "Spécialistes des toitures à Saint-Romuald depuis 12 années. Soumission gratuite en 2h, garantie écrite 10 ans.",
  hero_cta: "Demander ma soumission Saint-Romuald",
  hero_stat_1: 'Plusieurs dizaines de mises en relation à Saint-Romuald',
  hero_stat_2: 'Certifié',
  hero_stat_3: 'Garantie 10 ans',

  // Connaitre le quartier
  quartier_h2: "Pourquoi les toitures de Saint-Romuald demandent une expertise spécifique",
  quartier_p1: "Saint-Romuald, c'est un secteur d'arrondissement avec une majorité de maisons construites entre 1960 et 1985. Beaucoup de bungalows et split-levels avec toitures originales en bardeau d'asphalte qui ont dépassé leur durée de vie. La proximité du fleuve Saint-Laurent expose les toitures à des vents soutenus et des cycles d'humidité plus marqués qu'ailleurs à Lévis.",
  quartier_p2: "Les rues comme Saint-Joseph, de la Rivière-Etchemin et du Vieux-Quai concentrent aussi quelques maisons patrimoniales en ferblanterie traditionnelle qui exigent un savoir-faire particulier. On connaît chaque type de maison du secteur, et on adapte notre approche en conséquence.",

  // Problèmes typiques
  problemes_h2: "Les problèmes de toiture qu'on voit le plus à Saint-Romuald",
  probleme_1_title: 'BARDEAUX VIEILLISSANTS',
  probleme_1_desc: "Maisons des années 60-80 avec toitures originales ou première réfection des années 2000. Beaucoup arrivent en fin de vie simultanément.",
  probleme_2_title: 'DÉGÂTS DE VENT',
  probleme_2_desc: "Proximité du fleuve = vents soutenus. Bardeaux soulevés ou arrachés courants après les tempêtes d'automne et de printemps.",
  probleme_3_title: 'INFILTRATIONS BAS DE PENTE',
  probleme_3_desc: "Toitures à faible pente typiques des bungalows = barrages de glace fréquents l'hiver et infiltrations près des gouttières.",

  // Services
  services_h2: "Tous nos services de toiture à Saint-Romuald",
  service_1: "Réfection complète bardeau d'asphalte",
  service_2: "Réparation et infiltration d'urgence",
  service_3: "Toiture en tôle (popularité croissante)",
  service_4: "Toit plat membrane (pour annexes, garages)",
  service_5: 'Inspection gratuite avec rapport',
  service_6: 'Déneigement et déglaçage hiver',

  // Prix
  prix_h2: "Prix moyens d'une toiture à Saint-Romuald 2026",
  prix_table_type: 'Type de maison',
  prix_table_price: 'Fourchette bardeau 2026',
  prix_row_1_type: 'Bungalow 1 100-1 400 pi²',
  prix_row_1_price: '7 000 $ – 11 000 $',
  prix_row_2_type: 'Split-level 1 600-1 900 pi²',
  prix_row_2_price: '9 500 $ – 14 500 $',
  prix_row_3_type: 'Maison 2 étages 2 200+ pi²',
  prix_row_3_price: '12 000 $ – 19 000 $',
  prix_row_4_type: 'Mise à niveau en tôle',
  prix_row_4_price: '+60 % – 80 % au prix bardeau',
  prix_note: "Tarifs typiques observés à Saint-Romuald. Soumission précise après inspection sur place.",

  // Projets récents
  projets_h2: "Quelques projets récents à Saint-Romuald",
  projet_1_title: 'Rue Saint-Joseph',
  projet_1_desc: "Réfection complète bardeau architectural, août 2025, bungalow 1 300 pi²",
  projet_2_title: 'Rue de la Rivière-Etchemin',
  projet_2_desc: "Conversion bardeau vers tôle joint debout, juin 2025, cottage 2 étages",
  projet_3_title: 'Avenue Taniata',
  projet_3_desc: "Réparation infiltration urgence et remplacement section, mars 2025",

  // Témoignage
  temoignage_quote: "Notre maison sur la rue Saint-Joseph date de 1972. On avait acheté en 2018 et la toiture d'origine fuitait un peu chaque printemps. Marc-Antoine est venu inspecter, a pris des photos du pontage moisi, et nous a expliqué que c'était le moment ou jamais. L'équipe a fait toute la réfection en 3 jours, avec bardeau architectural IKO Cambridge. Ils ont même protégé nos plates-bandes avec des bâches. Depuis, zéro goutte. Notre voisin du 284 a déjà pris leur numéro. Ça se passe comme ça à Saint-Romuald.",
  temoignage_author: 'Hélène D.',
  temoignage_rue: 'Rue Saint-Joseph',
  temoignage_city: 'Saint-Romuald',
  temoignage_detail: "Réfection bardeau, juillet 2025",

  // Zones proches
  zones_h2: 'On dessert aussi les secteurs voisins',
  zone_saint_nicolas: 'Saint-Nicolas',
  zone_charny: 'Charny',
  zone_levis: 'Lévis centre',
  zone_pintendre: 'Pintendre',

  // CTA Final
  cta_h2: "Votre toiture à Saint-Romuald commence ici",
  cta_subtitle: 'Soumission gratuite en 2h, équipe locale, garantie 10 ans.',
  cta_button: "Demander ma soumission",
  cta_phone: '418-476-9950',

  // Shared
  phone_number: '418-476-9950',
};

export default saintromualdTranslations;